// extracted by mini-css-extract-plugin
module.exports = {"container":"header-module__container___PLK8N"};